module.exports = __webpack_public_path__ + "static/media/imtbike_logo.6c614389.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/imtbike_logo.jpg
// module id = 8210
// module chunks = 2